import { GameObj } from "../GameObj";
import { positionsInRadius } from "../geometry";
import { globals } from "../types";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class FireRain extends UnitType {
    readonly id = "fire rain";
    readonly displayName = "fire rain";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.overworld; }
    playerCanControl() { return false; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"], ctx.game.overworld); }
    description() { return "Destroys everything in a radius."; }
    maxCooldown() { return 0; }
    cost() { return { souls: 0, blood: 800, runes: 20 }; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "fire rain"); }
    defeats(): (string | true)[] { return [true]; }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {
        const { obj, world, x, y } = ctx;
        globals.audio.playSound("expl");
        // add animation maybe
        const positions = positionsInRadius(x, y, 1.5);
        for (const pos of positions) {
            const victim = world.get(pos.x, pos.y);
            if (victim && victim.id !== obj.id) ctx.game.stats.recordFireRainDestroyed();
            world.remove(pos.x, pos.y);
        }
        world.removeById(obj.id);
    }
}
